import api from '@/modules/composition/api';
import { getPopulateFieldsForCompositionModule } from '@/modules/entity/api';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { resolveEntityTypeFromFieldConfigAndFieldValue } from '@/modules/entity/utils';

export default {
  methods: {
    async fetchLegacyPopulatedFields(field, value) {
      return api.moduleGetFields({
        boardType: this.boardType,
        moduleType: this.moduleType,
        slotType: this.slotType,
        parentModuleType: get(this.moduleParentModule, 'type', null),
        parentModuleTemplate: get(this.moduleParentModule, 'fields.template', null),
        template: this.draft.template || null,
        fields: [{
          fieldName: field,
          fieldValue: value,
        }],
      });
    },

    async getTriggerPopulationEntityType(fieldConfig, value) {
      return resolveEntityTypeFromFieldConfigAndFieldValue(fieldConfig, value);
    },

    async fetchPopulatedFields(fieldConfig, field, value) {
      const type = await this.getTriggerPopulationEntityType(fieldConfig, value);
      if (!type) {
        return { [field]: value };
      }
      const fields = await getPopulateFieldsForCompositionModule(value, type, {
        triggerPopulationField: field,
        contextCompositionId: this.id,
        moduleType: this.moduleType,
        slotType: this.slotType,
        moduleTemplate: this.draft.template,
        draft: this.draft,
      });
      return {
        ...fields,
        [field]: value,
      };
    },

    /**
     * Returns the fields that has to be updated.
     * @param {string} field
     * @param {*}      value
     * @return {Promise<{}>}
     */
    async getPopulatedFields(field, value) {
      const fieldConfig = this.fieldsConfig.find(config => config.field === field) || {};
      const {
        triggerPopulation,
        usePopulateFieldsCmsApiService,
      } = fieldConfig;
      if (!value || (isArray(value) && isEmpty(value)) || !triggerPopulation) {
        return { [field]: value };
      }
      console.log('Fetching module fields from server. Triggered by updating ', field);
      this.fetchingData = true;
      const populated = usePopulateFieldsCmsApiService
        ? await this.fetchPopulatedFields(fieldConfig, field, value)
        : await this.fetchLegacyPopulatedFields(field, value);
      // Avoid overriding template field. @see https://mgr.bitban.com/issues/59130
      if (this.draft.template) {
        populated.template = this.draft.template;
      }
      console.log('Module fields fetched from server: ', populated);
      this.fetchingData = false;
      return populated;
    },
  },
};
